import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { ApiService, DataService, InspectionPluginService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { InstallationVoltagePluginFactoryService } from './voltage-plugin-factory.plugin';

@Injectable()
export class InstallationVoltagePluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private voltageFactory: InstallationVoltagePluginFactoryService
  ) {
    super(apiService, dataService, null);
  }

  public updateVoltage(inspectionId: string, pointId: string, pluginId: string, voltages: any[]): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, voltages).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, voltages: any[]): Observable<any> {
    return this.voltageFactory.updateVoltage(inspectionId, pointId, pluginId, voltages, 'Voltages').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
